import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useGetLojaAtualQuery } from '../api';
import type { RootState } from '../store';
import { ehTablet } from '../lib/canal';
import { BG_PADRAO_TABLET, ProtecaoTela, slidesComPadrao } from './protecao-tela';
import { useProtecaoOciosa } from '../lib/protecao-ociosa';

/** Tempo parado até a proteção VOLTAR depois de um toque. No repouso ela já
 *  aparece de cara — ver `useProtecaoOciosa`. */
const INATIVIDADE_MS = 30_000;

/**
 * Proteção de tela do modo TABLET: com o aparelho em repouso no início
 * (catálogo, sem carrinho) ela cobre a tela com as IMAGENS configuradas para a
 * mesa. Um toque nela dispensa e leva ao cardápio; parado
 * {@link INATIVIDADE_MS}, ela volta.
 *
 * Passava os produtos em destaque do cardápio quando a loja não subia imagem —
 * eram duas proteções de tela diferentes no mesmo modo, e a aba de configuração
 * prometia que ali apareceriam as imagens da mesa. Agora é só imagem, igual ao
 * totem e ao totem de checkout; sem nenhuma configurada entra o fundo de fábrica
 * da mesa ({@link BG_PADRAO_TABLET}), em paisagem — o tablet fica deitado.
 */
export function TabletAtracao(): JSX.Element | null {
  const { data: loja } = useGetLojaAtualQuery();
  const location = useLocation();
  const itens = useSelector((s: RootState) => s.carrinho.itens);

  const tablet = !!loja && ehTablet(loja.identificador);

  const slides = useMemo(
    () =>
      slidesComPadrao(
        (loja?.configuracao.imagensTablet ?? []).filter((u): u is string => !!u),
        BG_PADRAO_TABLET,
      ),
    [loja],
  );

  // Arma só quando o tablet está ocioso no início (catálogo, sem carrinho).
  const armado = tablet && location.pathname === '/catalogo' && itens.length === 0;

  const { visivel, dispensar } = useProtecaoOciosa(armado, INATIVIDADE_MS);

  if (!tablet || !visivel) return null;

  return (
    <ProtecaoTela
      slides={slides}
      chamadaAcima="Toque para"
      chamadaPrincipal="fazer seu pedido"
      aoTocar={dispensar}
    />
  );
}
